import { render } from "./CommentUserProfileActions.vue?vue&type=template&id=6c3bfc0f"
import script from "./CommentUserProfileActions.vue?vue&type=script&lang=js"
export * from "./CommentUserProfileActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__